define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi",
	"./SizeChart/_Number"
], function(declare,_,csi,NumberRen) {

	return declare(NumberRen, {
		bBaseRenderer: true,

		getIncrementValues: function(/*Context*/ctx, /*Heading?*/h) {
			var obj = ctx.getParam("_incrementValues");
			if (!obj) {
				var	node = ctx.getNode();

				var	inc = node[h.m_id];
				var n = inc.length;
				var abs = new Array(n);  // value on Absolute mode
				var bsIndex = this._getBaseSizeIndex(ctx);
				inc[bsIndex] = 0.0; // ignore base size increment value

				// Iterate the Increments value and calculate the abs array
				var incrementDimension = ctx.getNode();
				var apparelDimension = ctx.cache.getNode(incrementDimension.IncrementDimension);

				var incrementData = ctx.view.getIncrementData();
				if (incrementData && incrementData.isTwoDim()) {
					if (_.contains(apparelDimension.DimensionDependencies, incrementData.node.Dimension2Type))
						abs = incrementData.incrementToAbsolute(inc, true);
					else
						abs = incrementData.incrementToAbsolute(inc, false);
				} else {
					var i;

					abs[bsIndex] = 0.0;

					for (i = bsIndex - 1; i >= 0; --i) {
						abs[i] = abs[i+1] + inc[i];
					}

					for (i = bsIndex + 1; i < n; ++i) {
						abs[i] = abs[i-1] + inc[i];
					}
				}

				obj = {abs:abs,inc:inc.concat(),bsIndex:bsIndex};

				ctx.setParam("_incrementValues",obj);
			}

			return obj;
		},

		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			// summary: cell is empty and not editable if base size column
			return (ctx.keyValue == this._getBaseSizeIndex(ctx)) ? false : this.inherited(arguments);
		},

		toValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return empty string if dimension with blanks
			return ctx.getNode().Blanks ? csi.EMPTY_CHAR : this.inherited(arguments);
		},

		toValueDynamic: function(/*Context*/ctx, /*Heading*/h, /*Number?*/v) {
			// summary: return empty string if dimension with blanks - make sure to only apply when starting to edit
			// and not when checking _isValueChanged
			return ((v === undefined) && ctx.getNode().Blanks) ? "" : this.inherited(arguments);
		},

		_getRenderAction: function(/*Context*/ctx, /*Heading*/h) {
			// summary: restrict editing base size value
			return (ctx.keyValue == this._getBaseSizeIndex(ctx)) ? null : this.inherited(arguments);
		},

		_getBaseSizeIndex: function(/*Context*/ctx) {
			// summary: return base size index for Increment
			var	increment = ctx.getParent();
			var isTwoDim =  !_.isEmpty(increment.IncrementDimension2Sizes);

			var incrementDimension = ctx.getNode();
			var apparelDimension = ctx.cache.getNode(incrementDimension.IncrementDimension);

			// IncrementDimension of the ApparelDimension has NO matching Dimension2 type dependency,
			// the Increments matrix is displayed as one-dimensional with Increment's Dimension1 Size as column
			if (isTwoDim && !_.contains(apparelDimension.DimensionDependencies, increment.Dimension2Type)) {
				var baseSize = ctx.cache.getNode(increment.BaseSize);
				var baseSizeProductSize = ctx.cache.getNode(baseSize.IncrementSize);
				return _.indexOf(increment.IncrementDimension1Sizes, baseSizeProductSize.Dimension1Size);
			} else {
				return increment.BaseSizeIndex;
			}
		},

		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: extract stored value and convert to increment/relative/absolute value depending on custom view settings
			var val;

			if (this.isIncrementDisplay(ctx)) {
				val = this.inherited(arguments);
			} else {
				// for increments relative and absolute values are the same
				val = this.getIncrementValues(ctx,h).abs[Number(ctx.keyValue)];
			}

			return val;
		}
	});
});